import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import ReactSelect from "../../UI/ReactSelect";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  pin: "",
  duty: "",
  middleName: "",
  name: "",
  surname: "",
  personalNumber: "",
  source: "SAP",
  status: "ACTIVE",
  structureId: "",
  supervisor: "",
};

export default function Create(props) {
  const token = useSelector((state) => state.auth.token);
  const {
    show,
    onHide,
    onSaps,
    skip,
    take,
    filterInputs,
    orderBy,
    sortField,
    structureId,
    dutyId,
  } = props;
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
 const [status, setStatus] = React.useState("ACTIVE");
  const [chooseDutyIdOption, setChooseDutyIdOption] = React.useState(null);
  const [chooseStructureIdOption, setChooseStructureIdOption] = React.useState(
    null
  );
  const [open, setOpen] = React.useState(false);

  const CreateSchema = Yup.object().shape({
    pin: Yup.string().required("Fin kod tələb olunur."),
    // duty: Yup.string().required("Vəzifə tələb olunur."),
    // middleName: Yup.string().required("Ata adı tələb olunur."),
    name: Yup.string().required("Ad tələb olunur."),
    surname: Yup.string().required("Soyad tələb olunur."),
    // personalNumber: Yup.string().required("Şəxsi nömrə tələb olunur."),
    // structureId: Yup.string().required("Struktur ID tələb olunur."),
    // supervisor: Yup.string().required("Rəhbər tələb olunur."),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }
    return false;
  };

  const onPostPin = (values, resetForm, setSubmitting) => {
    setIsLoading(true);
    const employee = {
      pin: values.pin,
      duty: chooseDutyIdOption?.label,
      middleName: values.middleName,
      name: values.name,
      surname: values.surname,
      personalNumber: values.personalNumber,
      source: values.source,
      status: status,
      structureId: chooseStructureIdOption?.value,
      supervisor: values.supervisor,
    };
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}employee/new/`,
      headers: {
        Authorization: `bearer ${token}`,
      },
      data: {
        pin: employee.pin ? employee.pin : "",
        duty: employee.duty ? employee.duty : "",
        middleName: employee.middleName ? employee.middleName : "",
        name: employee.name ? employee.name : "",
        surname: employee.surname ? employee.surname : "",
        personalNumber: employee.personalNumber ? employee.personalNumber : "",
        source: "SAP",
        status: employee.status ? employee.status : "",
        structureId: employee.structureId ? employee.structureId : "",
        supervisor: employee.supervisor ? employee.supervisor : "",
      },
    })
      .then((res) => {
        onSaps(orderBy, sortField, skip, take, filterInputs);
        setSubmitting(false);
        resetForm();
        onHide(false);
        setIsLoading(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostPin(values, resetForm, setSubmitting);
    },
  });
  function handleChangeStructure(value) {
    setChooseStructureIdOption(value);
  }
  function handleChangeDuty(value) {
    setChooseDutyIdOption(value);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleOpen() {
    setOpen(true);
  }

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  return (
    <Modal
      size="xl"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="surname"
                    name="surname"
                    label="Soyad"
                    placeholder="Soyad"
                    className="w-100"
                    error={getInputClasses("surname")}
                    {...formik.getFieldProps("surname")}
                  />
                </div>
                {formik.touched.surname && formik.errors.surname ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.surname}</div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="pin"
                    name="pin"
                    label="Fin kod"
                    placeholder="Fin kod"
                    className="w-100"
                    error={getInputClasses("pin")}
                    {...formik.getFieldProps("pin")}
                  />
                </div>
                {formik.touched.pin && formik.errors.pin ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.pin}</div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="middleName"
                    name="middleName"
                    label="Ata adı"
                    placeholder="Ata adı"
                    className="w-100"
                    error={getInputClasses("middleName")}
                    {...formik.getFieldProps("middleName")}
                  />
                </div>
                {formik.touched.middleName && formik.errors.middleName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.middleName}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="personalNumber"
                    name="personalNumber"
                    label="Şəxsi nömrə"
                    placeholder="Şəxsi nömrə"
                    className="w-100"
                    error={getInputClasses("personalNumber")}
                    {...formik.getFieldProps("personalNumber")}
                  />
                </div>
                {formik.touched.personalNumber &&
                formik.errors.personalNumber ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.personalNumber}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <ReactSelect
                    suggestions={structureId}
                    handleChangeSingle={(value) => handleChangeStructure(value)}
                    single={chooseStructureIdOption}
                    label="Şirkət  seçin"
                    placeholder="Şirkət seçin"
                    inputId="structureId"
                  />
                </div>
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <ReactSelect
                    suggestions={dutyId}
                    handleChangeSingle={(value) => handleChangeDuty(value)}
                    single={chooseDutyIdOption}
                    label="Vəzifə"
                    placeholder="Vəzifə"
                    inputId="duty"
                  />
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="supervisor"
                    name="supervisor"
                    label="Birbaşa Rəhbər"
                    placeholder="Birbaşa Rəhbər"
                    className="w-100"
                    error={getInputClasses("supervisor")}
                    {...formik.getFieldProps("supervisor")}
                  />
                </div>
                {formik.touched.supervisor && formik.errors.supervisor ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.supervisor}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <FormControl className="w-100">
                    <InputLabel htmlFor="role">Vəziyyət</InputLabel>
                    <Select
                      open={open}
                      onClose={handleClose}
                      onOpen={handleOpen}
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      inputProps={{
                        name: "status",
                        id: "status",
                      }}
                    >
                      <MenuItem value="ACTIVE">Aktiv</MenuItem>
                      <MenuItem value="INACTIVE">Deaktiv</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
